export default "__VITE_ASSET__f14b69f2__"